// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://wjxrbvzzjgckkblbpcxc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndqeHJidnp6amdja2tibGJwY3hjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc4MDU0NDEsImV4cCI6MjA3MzM4MTQ0MX0.JS4aBcyKHEWavxbLLHp0WlVoE3mG-SF7zAjba9PbBhw";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});